<template>
  <div id="pageTable" class="subView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="">
              <v-form v-model="valid">
                <v-text-field
                  label="제목"
                  name="title"
                  v-model="formModel.title"
                  v-validate="'required'"
                  data-vv-name="title"     
                  :error-messages="errors.collect('title')"  
                  disabled
                  required
                ></v-text-field>
                <v-text-field
                  label="요청자이름"
                  name="requestUserName"
                  v-model="formModel.requestUserName"
                  v-validate="'required'"
                  data-vv-name="requestUserName"     
                  :error-messages="errors.collect('requestUserName')"  
                  disabled
                  required
                ></v-text-field>
                <v-text-field
                  label="요청자 전화번호"
                  name="requestUserPhoneNumber"
                  v-model="formModel.requestUserPhoneNumber"
                  v-validate="'required'"
                  data-vv-name="requestUserPhoneNumber"     
                  :error-messages="errors.collect('requestUserPhoneNumber')"  
                  disabled
                  required
                ></v-text-field> 
                <v-text-field
                  textarea
                  name="contents"
                  label="내용"
                  v-model="formModel.contents"
                  v-validate="'required'"
                  data-vv-name="contents"     
                  :error-messages="errors.collect('contents')"
                  disabled
                  required>
                </v-text-field>

                <v-dialog v-model="processStates.dialog" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">처리상태변경</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-select
                              :items="vocState"
                              v-model="formModel.state"
                              label="조치 상태"
                              item-text="text"
                              item-value="state"
                              :value="formModel.state"
                              >
                            </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field 
                              label="조치내용"
                              v-model="formModel.processComment"
                              v-validate="'required'"
                              data-vv-name="processComment"
                              :error-messages="errors.collect('processComment')"
                              required></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer>
                      </v-spacer>
                      <v-btn color="blue darken-1" flat @click="updateProcessStates">저장</v-btn>
                      <v-btn color="blue darken-1" flat @click="closeProcessStates">닫기</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                
                <v-list three-line subheader>
                  <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">처리 정보</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-data-table
                    :headers="complex.headers"
                    :items="complex.items"
                    :pagination.sync="complex.pagination"
                    :rows-per-page-items="[1]"
                    class="elevation-1"
                    item-key="id"
                    >
                    <template slot="items" slot-scope="props">            
                      <td class="text-sm-center">{{ props.item.processComment }}</td>
                      <td class="text-sm-center">{{ changeVocStateText(props.item.state) }}</td>
                      <td class="text-sm-center">{{ props.item.adminId }}</td>
                      <td class="text-sm-center">{{ props.item.modDate }}</td>
                    </template>
                  </v-data-table>
                </v-list>  
                <div class="form-btn">
                  <v-btn outline @click="openDialogProcessStates" color="primary">처리상태변경</v-btn>
                  <v-btn outline @click="editVOC" color="primary">수정</v-btn>
                  <v-btn outline @click="deleteVOC" color="primary">삭제</v-btn>
                  <v-btn outline @click="cancelVOC" color="primary">목록</v-btn>
                </div>
              </v-form>
            </v-card-text> 
          </v-card>    
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VocState from '@/api/vocState';

export default {
  $_veeValidate: {
    validator: 'new'
  },    
  data () {
    return {
      vocState: VocState,
      remainCount: null,
      formModel: {
        id: '0',
        title: '0',
        requestUserName: '0',
        contents: '0',
        requestUserPhoneNumber: '0',
        requestUserId: '',
        requestUserType: '',
        state: '',
        processComment: '',
      },
      valid: true,
      complex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '처리내용',
            value: 'processComment',
            sortable: false,
            align: 'center'
          },
          {
            text: '처리상태',
            value: 'state',
            sortable: false,
            width: '100',
            align: 'center'
          },
          {
            text: '담당자',
            value: 'adminId',
            sortable: false,
            width: '100',
            align: 'center'
          },
          {
            text: '처리일시',
            value: 'modDate',
            sortable: false,
            width: '150',
            align: 'center'
          },
        ],
        items: []
      },
      processStates: {
        dialog: false
      },
    };
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.$validator.localize('en', this.dictionary);
    this.banbanCreated();

    this.$el.getElementsByClassName('v-input v-textarea v-text-field v-text-field--enclosed v-text-field--outline v-input--is-label-active v-input--is-dirty v-input--is-disabled')[0].className = 'v-input v-textarea v-text-field v-text-field--enclosed v-text-field--outline v-input--is-label-active v-input--is-dirty';
    
    for (let i = this.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length -1; i >=0; i--) {
      this.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
    }
  },  
  methods: {
    banbanCreated () {
      const prameters = {
        method: 'searchVOCDetails',
        'id': this.$route.params.id
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.formModel.id = data.id;
          this.formModel.title = data.title;
          this.formModel.requestUserName = data.requestUserName;
          this.formModel.contents = data.contents;
          this.formModel.requestUserPhoneNumber = data.requestUserPhoneNumber;
          this.formModel.requestUserId = data.requestUserId;
          this.formModel.requestUserType = data.requestUserType;
          this.formModel.state = data.state;
          this.formModel.processComment = data.processComment;
          this.complex.items = [data];
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    submit () {
      
      this.$validator.validateAll()
        .then((validate) => {
          if (validate) {
            const parameters = {
              method: 'createVOC',
              title: this.formModel.title,
              contents: this.formModel.contents,
              requestUserName: this.formModel.requestUserName,
              requestUserPhoneNumber: this.formModel.requestUserPhoneNumber,
              requestUserId: this.formModel.requestUserId,
              requestUserType: this.formModel.requestUserType
            };
            this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
                alert('등록되었습니다');
                this.$router.go(-1);
              })
              .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
          }
       });;
    },
    changeVocStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.vocState.length; i++) {
          if (this.vocState[i].state === stateCode) {
            return this.vocState[i].text;
          }
        }
      } else {
        return '';
      }
    },
    openDialogProcessStates () {
      this.processStates.dialog = true;
    },
    editVOC () {
      this.$router.push('/voc/updateVoc/' + this.formModel.id);
    },
    deleteVOC () {
      if (confirm('정말 삭제하시겠습니까?')) {
        const prameters = {
          method: 'deleteVOC',
          id: this.formModel.id,
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            alert('삭제되었습니다.');
            top.getApp.progress.dialog = false;
            this.$router.go(-1);
          })
          .catch((error) => {
            if (top.getApp.commonError == null) {
              alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            }
            top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    cancelVOC () {
      this.$router.go(-1);
    },
    closeProcessStates () {
      this.processStates.dialog = false;
    },
    updateProcessStates () {
      this.$validator.validateAll()
        .then((validate) => {
          if (validate) {
            if (this.formModel.state == 'REGISTERED') {
              alert('처리상태를 변경해주세요');
            } else {
              const prameters = {
                method: 'updateProcessStates',
                id: this.formModel.id,
                state: this.formModel.state,
                processComment: this.formModel.processComment,
              };
              this.$store.dispatch('banbanAPI', prameters)
                .then(({ data }) => {
                  alert('처리되었습니다.');;
                  this.processStates.dialog = false;
                  top.getApp.progress.dialog = false;
                  this.banbanCreated();
                })
                .catch((error) => {
                  if (top.getApp.commonError == null) {
                    alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                  }
                  top.getApp.commonError = null;
                  top.getApp.progress.dialog = false;
                });
            }
          }
       });;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/voc/VOCDetail.vue